import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Card, CardBody, FormFeedback } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import moment from 'moment';

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { formatCurrency, formatDate } from '../../Utils/formatters';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import { saveAs } from 'file-saver';
import Papa from "papaparse";

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const UsersReport = props => {  
  const [modal_Delete_User, setmodal_Delete_User] = useState(false);
  function Delete_User() {
    setmodal_Delete_User(!modal_Delete_User);
    // removeBodyCss();
  }

  
  //meta title
  document.title = "Users Report";
	const location = useLocation();
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};
  
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      kyc_status: 'All',
      status: 'All',
      country: {label: 'All', value: 'All'},
      investment: 'All',
      crypto_wallet_deposit: 'All',
      crypto_wallet_used: 'All',
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = UsersData;
        if(values.kyc_status !== 'All') {
          filteredData = filteredData.filter(item => item.kyc_status === values.kyc_status);
        }
        if(values.status !== 'All') {
          filteredData = filteredData.filter(item => item.status === values.status);
        }
        if(values.country.value !== 'All') {
          filteredData = filteredData.filter(item => item.country === values.country.value);
        }
        if(values.investment !== 'All') {
          filteredData = filteredData.filter(item => item.investment === values.investment);
        }
        if(values.crypto_wallet_deposit !== 'All') {
          filteredData = filteredData.filter(item => item.crypto_wallet_deposit === values.crypto_wallet_deposit);
        }
        if(values.crypto_wallet_used !== 'All') {
          filteredData = filteredData.filter(item => item.crypto_wallet_used === values.crypto_wallet_used);
        }

        if(filteredData.length > 0) {
          handleT1Body(filteredData);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="9" className="text-center">No records found</td>
                        </tr>);

          setUsersTBody(tempTBody);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      u_id: elementData.u_id,
      status: elementData.status,
    });
    setStandardModal2(true);
  }

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      u_id: '',
      status: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Please select status'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          u_id: values.u_id,
          status: values.status
        });
        const res = await postRequest('update-user-status', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetUsers();
          setTimeout(() => {
            validation1.handleSubmit();
          }, 500);

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal2(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [UsersData, setUsersData] = React.useState([]);
  const [CsvData, setCsvData] = React.useState([]);
  const [UsersTBody, setUsersTBody] = React.useState('');

  // Customer.io migration: normalize the consent flag for export/display.
  const toConsentBool = (v) =>
    v === 1 || v === '1' || v === true ? 'TRUE'
      : v === 0 || v === '0' || v === false ? 'FALSE'
      : '';

  const handleT1Body = (tempData, properties = AllProperties) => {
    setCsvData(tempData);

    const formatAddressPart = (value) => {
      return value && value.trim() !== "" ? value : "";
    };


    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.u_id}</td>
        {/* Customer.io: internal user ID column */}
        <td>tkg_{element.u_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.email}</td>
        {/* Customer.io: consent columns, placed right after Email */}
        <td>{toConsentBool(element.want_to_subscribe_mailchimp)}</td>
        <td>{element.created_at ? moment(element.created_at).format('DD/MM/YYYY') : "-"}</td>
        <td>{element.country}</td>
        <td>+{element.country_code} {element.phone}&nbsp;
          {parseInt(element.is_phone_verified) === 1 ? (
            <CheckCircleIcon style={{ color: 'green' }} />
          ) : (
            <CancelIcon style={{ color: 'red' }} />
          )}
        </td>
        <td>
          {(() => {
            if (element.dob) {
              return moment(element.dob).format('DD/MM/YYYY');
            } else {
              return "-";
            }
          })()}
        </td>
        {/* <td>
          {(() => {
            const fullAddress = [
              formatAddressPart(element.street),
              formatAddressPart(element.city),
              formatAddressPart(element.postal_code),
              formatAddressPart(element.state),
              formatAddressPart(element.address_country),
            ]
              .filter(part => part.trim() !== "") // remove empty parts
              .join(" ")
              .trim();

            // If fullAddress is empty, fall back to element.address
            return fullAddress !== "" ? fullAddress : (element.address || "-");
          })()}
        </td> */}
        <td>{element.address}</td>
        <td>{element.building}</td>
        <td>{element.floor}</td>
        <td>{element.zip}</td>
        <td>{element.tax_residency}</td>
        <td>{element.tax_id}</td>

        <td>
          <span className={
            "font-size-14 badge bg-secondary rounded-pill " +
            (element.kyc_status === 'Pending'
              ? 'badge-soft-warning'
              : element.kyc_status === 'Approved'
                ? 'badge-soft-success'
                : 'badge-soft-danger')
          }>
            {element.kyc_status}
          </span>
        </td>
        <td>
          {(() => {
            if (element.kyc_status === 'Pending') {
              return "-";
            }
            if (element.kyc_date) {
              return moment(element.kyc_date).format('DD/MM/YYYY HH:mm');
            } else {
              const kycObject = JSON.parse(element.kyc_response);
              return moment(kycObject.createdUtc).format('DD/MM/YYYY HH:mm');
            }
          })()}
        </td>
        <td>
          <span className={
            "font-size-14 badge bg-secondary rounded-pill " +
            (element.status === 'Enable' ? 'badge-soft-success' : 'badge-soft-danger')
          }>
            {element.status}
          </span>
        </td>
        <td>{moment(element.created_at).format('DD/MM/YYYY HH:mm')}</td>
        <td>{element.investment}</td>
        <td>{element.investment_amount_eur === 0 ? "" : `${element.investment_amount_eur} EUR `} {element.investment_amount_usdt === 0 ? "" : `${element.investment_amount_usdt} USDT`}</td>
        <td>{formatCurrency(element.euro_available_balance)}</td>
        <td>{`${parseFloat(element.matic_available_balance).toFixed(2)} MATIC`}</td>
        <td>{`${parseFloat(element.usdt_available_balance).toFixed(2)} USDT`}</td>
        <td>{formatCurrency(element.total_bonus)}</td>
        <td>{formatCurrency(element.total_bonus-element.used_bonus)}</td>
        <td>{formatCurrency(element.total_dividend)}</td>
        <td>{formatCurrency(element.total_dividend-element.used_dividend)}</td>
        <td>{formatCurrency(Math.max(0, parseFloat((element.used_claimed + element.used_dividend) - element.total_withdrawal) || 0))}</td>
        <td>{formatCurrency(element.total_withdrawal)}</td>
        {/* 🔹 Dynamically generate property columns */}
        {/* {properties.map((token, idx) => (
          <td key={idx}>
            {element.property_investments[token]
              ? `${element.property_investments[token]} EUR`
              : "-"}
          </td>
        ))} */}

        {properties.map((token, idx) => (
          <td key={idx}>
            {element.property_investments[token]
              ? [
                  element.property_investments[token].Euro == 0
                    ? ""
                    : `${Number(element.property_investments[token].Euro)} EUR`,
                  element.property_investments[token].USDT == 0
                    ? ""
                    : `${Number(element.property_investments[token].USDT)} USDT`
                ].filter(Boolean).join(" ")
              : "-"}
          </td>
        ))}



        <td>{element.crypto_wallet_deposit}</td>
        <td>{element.crypto_wallet_deposit === "No" ? "-" : element.crypto_wallet_used}</td>
        <td>{element.utm_source?element.utm_source:"-"}</td>
        <td>{element.utm_medium?element.utm_medium:"-"}</td>
        <td>{element.utm_campaign?element.utm_campaign:"-"}</td>
        <td>{element.referrer?element.referrer:"-"}</td>
        <td>{element.first_touch_url?element.first_touch_url:"-"}</td>
        <td>
          {(() => {
            if (element.first_touch_at) {
              return moment(element.first_touch_at).format('DD/MM/YYYY HH:mm');
            } else {
              return "-";
            }
          })()}
        </td>
        <td>{element.first_site_landing_url?element.first_site_landing_url:"-"}</td>
      </tr>
    ));

    setUsersTBody(tempTBody);
  };


  const handleDownloadCSV = () => {
    const formatAddressPart = (value) => {
      return value && value.trim() !== "" ? value : "";
    };

    const transformedData = CsvData.map(user => {
      // Static fields before property columns
      const data = {
        // Customer.io: internal user ID so profiles (imported by email) can be
        // linked to their tkg_ ID.
        "User ID": `tkg_${user.u_id}`,
        "First Name": user.first_name,
        "Last Name": user.last_name,
        "Email": user.email,
        // Customer.io: consent columns, right after Email. Date only (DD/MM/YYYY).
        "Email Marketing Consent": toConsentBool(user.want_to_subscribe_mailchimp),
        "Email Marketing Consent Date": user.created_at
          ? moment(user.created_at).format('DD/MM/YYYY')
          : "-",
        "Country": user.country,
        "Phone": `+${user.country_code} ${user.phone}`,
        "Date Of Birth": (() => {
          if (user.dob) {
            return moment(user.dob).format('DD/MM/YYYY');
          } else {
            return "-";
          }
        })(),
        // "Address": formatAddressPart(user.street)+" "+formatAddressPart(user.city)+" "+formatAddressPart(user.postal_code)+" "+formatAddressPart(user.state)+" "+formatAddressPart(user.address_country),
        "Address": user.address ? user.address : "-",
        "Building": user.building ? user.building : "-",
        "Floor": user.floor ? user.floor : "-",
        "Zip": user.zip ? user.zip : "-",
        "Tax Residency": user.tax_residency,
        "Tax_id": user.tax_id,
        "KYC Status": user.kyc_status,
        "KYC Date": (() => {
          if (user.kyc_status === 'Pending') {
            return "-";
          }
          if (user.kyc_date) {
            return moment(user.kyc_date).format('DD/MM/YYYY HH:mm');
          } else {
            const kycObject = JSON.parse(user.kyc_response);
            return moment(kycObject.createdUtc).format('DD/MM/YYYY HH:mm');
          }
        })(),
        "Register Date": moment(user.created_at).format('DD/MM/YYYY HH:mm'),
        "Investment": user.investment,
        "Investment Amount": user.investment_amount_eur === 0 ? "-" : `${user.investment_amount_eur} EUR ` + (user.investment_amount_usdt === 0 ? "" : `${user.investment_amount_usdt} USDT`),
      };

      // // 🔹 Add dynamic property columns right after "Investment Amount"
      // AllProperties.forEach(token => {
      //   data[`${token} Amount`] = user.property_investments[token]
      //     ? `${user.property_investments[token]} EUR`
      //     : "-";
      // });

      AllProperties.forEach(token => {
        const tokenData = user.property_investments[token];
        if (tokenData) {
          const eur = tokenData.Euro == 0 ?  "" : `${Number(tokenData.Euro)} EUR`;
          const usdt = tokenData.USDT == 0 ? "" : `${Number(tokenData.USDT)} USDT`;
          const combined = [eur, usdt].filter(Boolean).join(" ");
          data[`${token} Amount`] = combined || "-";
        } else {
          data[`${token} Amount`] = "-";
        }
      });

      // Remaining fields after dynamic properties
      data["Deposit Crypto Wallet"] = user.crypto_wallet_deposit;
      data["Used Crypto Wallet"] = user.crypto_wallet_deposit === "No" ? "-" : user.crypto_wallet_used;
      data["Euro Wallet Amount"] = formatCurrency(user.euro_available_balance || 0);
      data["Matic Wallet Amount"] = `${parseFloat(user.matic_available_balance || 0).toFixed(2)} MATIC`;
      data["USDT Wallet Amount"] = `${parseFloat(user.usdt_available_balance || 0).toFixed(2)} USDT`;
      data["Total Bonus"] = formatCurrency(user.total_bonus || 0);
      data["Bonus Balance"] = formatCurrency(user.total_bonus-user.used_bonus);
      data["Total Dividend"] = formatCurrency(user.total_dividend);
      data["Dividend Balance"] = formatCurrency(user.total_dividend-user.used_dividend);
      data["Total Re-Invested"] = formatCurrency(Math.max(0, parseFloat((user.used_claimed + user.used_dividend) - user.total_withdrawal) || 0));
      data["Total Withdrawn"] = formatCurrency(user.total_withdrawal || 0);
      data["UTM Source"] = user.utm_source ? user.utm_source : "-";
      data["UTM Medium"] = user.utm_medium ? user.utm_medium : "-";
      data["UTM Campaign"] = user.utm_campaign ? user.utm_campaign : "-";
      data["Referrer"] = user.referrer ? user.referrer : "-";
      data["first Touch URL"] = user.first_touch_url ? user.first_touch_url : "-";
      data["First Touch At"] = (() => {
          if (user.first_touch_at) {
            return moment(user.first_touch_at).format('DD/MM/YYYY HH:mm');
          } else {
            return "-";
          }
        })()
      data["UTM Term"] = user.utm_term ? user.utm_term : "-";
      data["UTM Content"] = user.utm_content ? user.utm_content : "-";
      data["Gclid"] = user.gclid ? user.gclid : "-";
      data["Fbclid"] = user.fbclid ? user.fbclid : "-";
      data["Landing URL"] = user.landing_url ? user.landing_url : "-";
      data["First Site Landing URL"] = user.first_site_landing_url ? user.first_site_landing_url : "-";

      return data;
    });

    // 🔹 Generate CSV
    const csv = Papa.unparse(transformedData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    // 🔹 Create filename with current datetime
    const currentDateTime = moment().format('DDMMYYYY_HHmmss');
    const filename = `users-report_${currentDateTime}.csv`;

    saveAs(blob, filename);
  };

  const [AllProperties, setAllProperties] = React.useState([]);

  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let originalText = res.data;

      const walletDeposits = await handleLoadGetWalletCredit();
      const investments = await handleLoadGetPropertyInvestment();
      const updatedUsers = await Promise.all(
        originalText.map(async (element) => {
          let is_investment = "No";
          let total_value_token_price_eur = 0;
          let total_value_token_price_usdt = 0;
          let crypto_wallet_used = "No";

          investments.crypto_transaction.forEach(investment => {
            if (element.u_id == investment.u_id) {
              crypto_wallet_used = "Yes";
            }
          });

          let propertyInvestments = {};
          investments.crypto_transaction.forEach((investment) => {
            if (element.u_id === investment.u_id) {
              is_investment = "Yes";
              if(investment.currency === "Euro"){
                total_value_token_price_eur += parseFloat(investment.total_amount);
              }else if(investment.currency === "USDT"){
                total_value_token_price_usdt += parseFloat(investment.total_amount);
              }
              
              // if (!propertyInvestments[investment.token_symbol]) {
              //   propertyInvestments[investment.token_symbol] = 0;
              // }
              // propertyInvestments[investment.token_symbol] += parseFloat(investment.total_amount);

              if (!propertyInvestments[investment.token_symbol]) {
                propertyInvestments[investment.token_symbol] = { Euro: 0, USDT: 0 };
              }

              propertyInvestments[investment.token_symbol][investment.currency] += Number(investment.total_amount);
            }
          });

          if (total_value_token_price_eur === 0 && total_value_token_price_usdt === 0 ) {
            is_investment = "No";
          }

          let wallet_credit = "No";
          walletDeposits.forEach(wallet => {
            if (element.u_id == wallet.u_id) {
              wallet_credit = "Yes";
            }
          });

          return {
            ...element,
            investment: is_investment,
            investment_amount_eur: total_value_token_price_eur,
            investment_amount_usdt: total_value_token_price_usdt,
            crypto_wallet_deposit: wallet_credit,
            crypto_wallet_used: crypto_wallet_used,
            property_investments: propertyInvestments,
          };
        })
      );

      // **Get all unique property tokens**
      // const allProps = new Set();
      // updatedUsers.forEach(user => {
      //   Object.keys(user.property_investments || {}).forEach(token => {
      //     allProps.add(token);
      //   });
      // });
      // setAllProperties([...allProps]);

      // setUsersData(updatedUsers);
      // setCsvData(updatedUsers);
      // handleT1Body(updatedUsers, [...allProps]);

      const allProps = new Set();
      updatedUsers.forEach(user => {
        Object.keys(user.property_investments || {}).forEach(token => allProps.add(token));
      });
      const sortedProps = [...allProps].sort((a,b) => a.localeCompare(b));
      setAllProperties(sortedProps);

      setUsersData(updatedUsers);
      setCsvData(updatedUsers);
      handleT1Body(updatedUsers, sortedProps);
    } else {
      let tempTBody = (
        <tr>
          <td colSpan="9" className="text-center">No records found</td>
        </tr>
      );

      setUsersTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  };


  const handleLoadGetPropertyInvestment = async () => {
    const res = await postRequest('get-all-user-property-investment');
    if (res && res.code === 200) {
      return res.data;
    }
    else {
      return [];
    }
  }

  const handleLoadGetWalletCredit = async () => {
    const res = await getRequest('get-fiat-credit-data');
    if (res && res.code === 200) {
      return res.data;
    }
    else {
      return [];
    }
  }

  const [AllCountriesData, setAllCountriesData] = React.useState([]);
  const handleLoadGetAllCountries = async () => {
    const res = await getRequest('get-all-countries');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempArr = [{label: 'All', value: 'All'}];
      originalText.forEach(element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesData(tempArr);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  React.useEffect(() => {
    handleLoadGetUsers();
    handleLoadGetAllCountries();

    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
		}
  }, []);


  // Add HubSpot configuration
  const [isHubSpotSyncing, setIsHubSpotSyncing] = React.useState(false);

  const syncToHubSpot = async () => {
    try {
      setIsHubSpotSyncing(true);
      let submitBtn = document.getElementById('submit4');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Syncing...';
      }

      const hubspotData = CsvData.map(user => ({
        properties: {
          firstname: user.first_name || "-",
          lastname: user.last_name || "-",
          email: user.email,
          country: user.country || "-",
          mobilephone: user.phone ? `+${user.country_code} ${user.phone}` : "-",
          birthdate1: user.dob ? moment(user.dob).valueOf() : null,
          address: user.address || "-",
          building: user.building || "-",
          floor: user.floor || "-",
          tax_residency: user.tax_residency || "-",
          tax_id: user.tax_id || "-",
          kyc_status: user.kyc_status,
          kyc_date: (() => {
            if (user.kyc_status === 'Pending') return null;
            if (user.kyc_date) return moment(user.kyc_date).valueOf();
            try {
              const kycObject = JSON.parse(user.kyc_response);
              return moment(kycObject.createdUtc).valueOf();
            } catch {
              return null;
            }
          })(),
          register_date: user.created_at ? moment(user.created_at).valueOf() : null,
          investment: user.investment === "Yes",
          investment_amount: Number(user.investment_amount_eur) !== 0 ? `${Number(user.investment_amount_eur)}`
          : Number(user.investment_amount_usdt) !== 0 ? `${Number(user.investment_amount_usdt)}`
          : 0,
          euro_wallet_amount: user.euro_available_balance || 0,
          matic_wallet_amount: user.matic_available_balance || 0,
          usdt_wallet_amount: user.usdt_available_balance || 0,
          total_bonus: user.total_bonus || 0,
          available_bonus: (Number(user.total_bonus) - Number(user.used_bonus)).toFixed(2) || 0,
          total_dividend: user.total_dividend || 0,
          available_dividend: (Number(user.total_dividend) - Number(user.used_dividend)).toFixed(2) || 0,
          re_invested: Math.max(0, (Number(user.used_claimed) + Number(user.used_dividend) - Number(user.total_withdrawal))).toFixed(2) || 0,
          total_withdrawal: user.total_withdrawal || 0,
          utm_source: user.utm_source || "-",
          utm_medium: user.utm_medium || "-",
          utm_campaign: user.utm_campaign || "-",
          first_touch_url: user.first_touch_url || "-",
          first_touch_at: user.first_touch_at ? moment(user.first_touch_at).valueOf() : null,
          utm_term: user.utm_term || "-",
          utm_content: user.utm_content || "-",
          gclid: user.gclid || "-",
          fbclid: user.fbclid || "-",
          landing_url: user.landing_url || "-",
          first_site_landing_url: user.first_site_landing_url || "-",
        }
      }));

      // Add property investments as custom properties
      AllProperties.forEach(token => {
        hubspotData.forEach((contact, idx) => {
          const user = CsvData[idx];
          const tokenData = user.property_investments[token];

          // 🔹 Format token name: remove "TKG-" and convert to lowercase
          const formattedTokenName = token.replace(/^TKG-/i, '').toLowerCase();

          if (tokenData) {
            const EUR = Number(tokenData.Euro) !== 0 ? `${Number(tokenData.Euro)}` : "";
            const USDT = Number(tokenData.USDT) !== 0 ? `${Number(tokenData.USDT)}` : "";
            const amount = EUR || USDT || 0;
            if(formattedTokenName === 'eco3') {
              contact.properties[`${formattedTokenName}_amount1`] = amount || 0;
            }
            else {
              contact.properties[`${formattedTokenName}_amount`] = amount || 0;
            }
          } else {
            if(formattedTokenName === 'eco3') {
              contact.properties[`${formattedTokenName}_amount1`] = 0;
            }
            else {
              contact.properties[`${formattedTokenName}_amount`] = 0;
            }
          }
        });
      });

      // Send to backend API endpoint
      const jsonpar = JSON.stringify({
        contacts: hubspotData
      });
      
      const res = await postRequest('sync-user-data-to-hubspot', jsonpar);
      
      if (res && res.code === 200) {
        setAlertData({
          variant: 'success',
          message: `Successfully synced ${hubspotData.length} contacts to HubSpot`,
        });
      } else {
        setAlertData({
          variant: 'error',
          message: res.message || 'Failed to sync to HubSpot',
        });
      }
      resetAlertData();

      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Sync to HubSpot';
      }
      setIsHubSpotSyncing(false);
    } catch (error) {
      console.error("HubSpot sync error:", error);
      setAlertData({
        variant: 'error',
        message: 'Error syncing to HubSpot',
      });
      resetAlertData();
      setIsHubSpotSyncing(false);
      let submitBtn = document.getElementById('submit4');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Sync to HubSpot';
      }
    }
  };

  return (
    <React.Fragment>
      <style>{`
        .fixed-solution {
          max-height: calc(100vh - 260px);
          overflow-y: auto;
          position: relative;
        }

        .fixed-solution .sticky-table-header th {
          position: sticky !important;
          top: 0 !important;
          z-index: 10 !important;
          background: #EFF2F7 !important;
        }

        .fixed-solution .sticky-table-header th:first-child {
          z-index: 11 !important;
        }
      `}</style>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Users Report")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="row">
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">KYC Status : </label>
                          <select className="form-select" name="kyc_status" value={validation1.values.kyc_status} onChange={(e) => validation1.setValues({ ...validation1.values, kyc_status: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Pending'}>Pending</option>
                            <option value={'Approved'}>Approved</option>
                            <option value={'Cancelled'}>Cancelled</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Status : </label>
                          <select className="form-select" name="status" value={validation1.values.status} onChange={(e) => validation1.setValues({ ...validation1.values, status: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Enable'}>Enable</option>
                            <option value={'Disable'}>Disable</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3 Register-Select2">
                          <label className="form-label">Country : </label>
                          <Select styles={colourStyles} value={validation1.values.country} onChange={(e) => validation1.setValues({ ...validation1.values, country: e })} options={AllCountriesData} classNamePrefix="select2-selection" />
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Investment : </label>
                          <select className="form-select" name="investment" value={validation1.values.investment} onChange={(e) => validation1.setValues({ ...validation1.values, investment: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Yes'}>Yes</option>
                            <option value={'No'}>No</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Deposit Crypto Wallet : </label>
                          <select className="form-select" name="crypto_wallet_deposit" value={validation1.values.crypto_wallet_deposit} onChange={(e) => validation1.setValues({ ...validation1.values, crypto_wallet_deposit: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Yes'}>Yes</option>
                            <option value={'No'}>No</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Used Crypto Wallet : </label>
                          <select className="form-select" name="crypto_wallet_used" value={validation1.values.crypto_wallet_used} onChange={(e) => validation1.setValues({ ...validation1.values, crypto_wallet_used: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Yes'}>Yes</option>
                            <option value={'No'}>No</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={6} xs={12}>
                        <div className="mb-3">
                          <label className="form-label fullWidth">&nbsp; </label>
                          <Button type="button" id="submit1" onClick={(e) => { e.preventDefault(); validation1.handleSubmit(); return false; }} color="primary" style={{ float: "left"}} >Search</Button>
                          <Button type="button" id="submit3" onClick={handleDownloadCSV} color="primary" className="bx bx-download" style={{ float: "right", marginLeft: "10px"}} />
                          <Button type="button" id="submit4" onClick={syncToHubSpot} color="primary" disabled={isHubSpotSyncing || CsvData.length === 0} style={{ float: "right"}}>
                            Sync to HubSpot
                          </Button>
                        </div>
                      </Col>
                    </div>
                    <div className="table-responsive mb-0 fixed-solution">
                      <table className="table table-hover table-highlight" style={{ minWidth: '2100px' }}>
                        <thead className="sticky-table-header">
                          <tr>
                            <th>#</th>
                            <th>User ID</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email ID</th>
                            <th>Email Marketing Consent</th>
                            <th>Email Marketing Consent Date</th>
                            <th>Country Name</th>
                            <th>Mobile No.</th>
                            <th>Date Of Birth</th>
                            <th>Address</th>
                            <th>Building</th>
                            <th>Floor</th>
                            <th>Zip Address</th>
                            <th>Tax Residency</th>
                            <th>Tax ID</th>
                            <th>KYC Status</th>
                            <th>KYC Date</th>
                            <th>Status</th>
                            <th>Register Date</th>
                            <th>Investment</th>
                            <th>Investment Amount</th>
                            <th>Euro Wallet Amount</th>
                            <th>Matic Wallet Amount</th>
                            <th>USDT Wallet Amount</th>
                            <th>Total Bonus</th>
                            <th>Bonus Balance</th>
                            <th>Total Dividend</th>
                            <th>Dividend Balance</th>
                            <th>Total Re-Invested</th>
                            <th>Total Withdrawn</th>

                            {AllProperties.map((token, idx) => (
                              <th key={idx}>{token}</th>
                            ))}

                            <th>Deposit Crypto Wallet</th>
                            <th>Used Crypto Wallet</th>
                            <th>UTM Source</th>
                            <th>UTM Medium</th>
                            <th>UTM Campaign</th>
                            <th>Referrer</th>
                            <th>First Touch Url</th>
                            <th>First Touch At</th>
                            <th>First Site Landing URL</th>
                          </tr>
                        </thead>

                        <tbody>
                          {UsersTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(UsersReport);
